import React, { useState } from 'react';

function SettingsManagement() {
  const [settings, setSettings] = useState({
    siteName: 'Ortus',
    currency: 'INR',
    taxRate: 18,
    shippingFee: 50,
    freeShippingThreshold: 500,
    maintenanceMode: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings({
      ...settings,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Settings saved (demo).');
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Settings</h2>

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 space-y-4 max-w-xl">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Site Name</label>
          <input name="siteName" value={settings.siteName} onChange={handleChange} className="w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Currency</label>
          <select name="currency" value={settings.currency} onChange={handleChange} className="w-full border rounded p-2">
            <option value="INR">INR</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Tax Rate (%)</label>
          <input name="taxRate" type="number" value={settings.taxRate} onChange={handleChange} className="w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Shipping Fee</label>
          <input name="shippingFee" type="number" value={settings.shippingFee} onChange={handleChange} className="w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Free Shipping Threshold</label>
          <input name="freeShippingThreshold" type="number" value={settings.freeShippingThreshold} onChange={handleChange} className="w-full border rounded p-2" />
        </div>
        <div className="flex items-center gap-2">
          <input name="maintenanceMode" type="checkbox" checked={settings.maintenanceMode} onChange={handleChange} />
          <label className="text-sm font-medium text-gray-700">Maintenance Mode</label>
        </div>
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Save Settings</button>
      </form>
    </div>
  );
}

export default SettingsManagement;
